/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from '../../../sis-components.module';
import { AttainmentTreeModule } from './attainment-tree.module';
import { AttainmentTreeService } from './attainment-tree.service';
import { EditableAttainmentTreeGroupingModuleComponent } from './editable-attainment-tree-grouping-module.component';
import { EditableAttainmentTreeRootWrapperComponent } from './editable-attainment-tree-root-wrapper.component';
import { EditableAttainmentTreeRootComponent } from './editable-attainment-tree-root.component';
import { EditableAttainmentTreeStudySelectionsComponent } from './editable-attainment-tree-study-selections.component';

@NgModule({
    declarations: [
        EditableAttainmentTreeGroupingModuleComponent,
        EditableAttainmentTreeRootComponent,
        EditableAttainmentTreeRootWrapperComponent,
        EditableAttainmentTreeStudySelectionsComponent,
    ],
    imports: [AttainmentTreeModule, CommonModule, SisCommonModule, SisComponentsModule, TranslateModule.forChild()],
    exports: [EditableAttainmentTreeRootWrapperComponent, EditableAttainmentTreeRootComponent],
    providers: [AttainmentTreeService],
})
export class EditableAttainmentTreeModule {}
